import type { WrapperGS } from "../WrapperGS";
import type { StateGS } from "./StateGS";

export type StatePagedContractGS = StateGS & {
    readonly layoutName: string;
    readonly page: WrapperGS;
};

export function isStatePagedGS(state: StateGS): state is StatePagedContractGS {
    const candidate = state as StateGS & Partial<StatePagedContractGS>;
    return typeof candidate.layoutName === "string" && candidate.page !== undefined;
}
